import { useState } from "react";
import { useLang } from "@/lib/i18n";
import OrnamentoDourado from "./OrnamentoDourado";

export default function NewsletterCTA() {
  const [email, setEmail] = useState("");
  const [enviado, setEnviado] = useState(false);
  const { t } = useLang();

  const submit = (e) => {
    e.preventDefault();
    if (!email.includes("@")) return;
    setEnviado(true);
    setTimeout(() => { setEmail(""); }, 200);
  };

  return (
    <section
      className="relative mt-32 border-y border-[var(--cor-borda)] bg-[var(--cor-fundo-2)]/40 px-6 py-24"
      data-testid="newsletter-section"
    >
      <div className="mx-auto max-w-2xl text-center">
        <div className="font-display text-[10px] uppercase tracking-[0.32em] text-[var(--cor-dourado)]">
          {t.diariamente}
        </div>
        <OrnamentoDourado simbolo="❧" className="mt-5" />
        <h2 className="font-display text-4xl md:text-5xl text-[var(--cor-texto)] mt-8 font-light leading-tight">
          {t.receber_diario}
        </h2>
        <p className="font-serif text-[var(--cor-texto-2)] mt-5 text-lg leading-relaxed">
          {t.junta_te}
        </p>

        {enviado ? (
          <div
            className="mt-10 font-display text-[var(--cor-dourado-claro)] uppercase tracking-[0.22em] text-sm"
            data-testid="newsletter-success"
          >
            {t.inscricao_sucesso}
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto" data-testid="newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email@exemplo.pt"
              className="flex-1 bg-transparent border-b border-[var(--cor-borda)] focus:border-[var(--cor-dourado)] px-2 py-3 font-serif text-[var(--cor-texto)] placeholder:text-[var(--cor-texto-2)] outline-none transition-colors"
              data-testid="newsletter-email-input"
            />
            <button
              type="submit"
              className="font-display text-sm uppercase tracking-[0.22em] text-[var(--cor-dourado)] border border-[var(--cor-dourado)]/40 px-8 py-3 rounded-full hover:bg-[var(--cor-dourado)]/10 hover:text-[var(--cor-dourado-claro)] transition-all duration-500"
              data-testid="newsletter-submit-btn"
            >
              {t.subscrever}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
